module.exports = __webpack_public_path__ + "img/news04.318dfc00.png";